import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import ActionButtons from "../components/ActionButtons";
import Header from "../components/Header";
import Loader from "../components/Loader";
import { fields, LOCAL_STORAGE_KEY } from "../constants";
import { getDetailsApi } from "../utils/api";
import { mergeLookupDetails } from "../utils/lookupDetails";

// Tamil Nadu keeps its own dropdown data. These values mirror the Andhra Pradesh
// form without creating a dependency between the two state forms.
const tamilNaduVehicleTypes = ["TRANSPORT", "NON-TRANSPORT"];
const tamilNaduVehicleClasses = [
  { name: "OMNI BUS", category: "TRANSPORT", type: "PASSENGER" },
  { name: "BUS", category: "TRANSPORT", type: "PASSENGER" },
  { name: "EDUCATIONAL INSTITUTION BUS", category: "TRANSPORT", type: "PASSENGER" },
  { name: "MOTOR CAB", category: "TRANSPORT", type: "PASSENGER" },
  { name: "MAXI CAB", category: "TRANSPORT", type: "PASSENGER" },
  { name: "PRIVATE SERVICE VEHICLE", category: "TRANSPORT", type: "PASSENGER" },
  { name: "HEARSES", category: "TRANSPORT", type: "PASSENGER" },
  { name: "GOODS CARRIER", category: "TRANSPORT", type: "GOODS" },
  { name: "CASH VAN", category: "TRANSPORT", type: "GOODS" },
  { name: "POWER TILLER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "DUMPER", category: "TRANSPORT", type: "GOODS" },
  { name: "MULTI-AXLED GOODS", category: "TRANSPORT", type: "GOODS" },
  { name: "TRAILER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "SEMI-TRAILER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "MODULAR HYDRAULIC TRAILER", category: "TRANSPORT", type: "GOODS" },
  { name: "AUXILIARY TRAILER", category: "TRANSPORT", type: "GOODS" },
  { name: "TRACTOR-TROLLEY (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "TRACTOR (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
  { name: "CHASSIS OF VEHICLES", category: "TRANSPORT", type: "GOODS" },
  { name: "ARTICULATED VEHICLE", category: "TRANSPORT", type: "GOODS" },
  { name: "AMBULANCE", category: "TRANSPORT", type: "GOODS" },
  { name: "ANIMAL AMBULANCE", category: "TRANSPORT", type: "GOODS" },
  { name: "FIRE TENDERS", category: "TRANSPORT", type: "GOODS" },
  { name: "LIBRARY VAN", category: "TRANSPORT", type: "GOODS" },
  { name: "X-RAY VAN", category: "TRANSPORT", type: "GOODS" },
  { name: "MOBILE WORKSHOP", category: "TRANSPORT", type: "GOODS" },
  { name: "MOBILE CANTEEN", category: "TRANSPORT", type: "GOODS" },
  { name: "SNORKEL LADDERS", category: "TRANSPORT", type: "GOODS" },
  { name: "MOBILE CLINIC", category: "TRANSPORT", type: "GOODS" },
  { name: "VEHICLE FITTED WITH RIG", category: "NON-TRANSPORT" },
  { name: "EARTH MOVING EQUIPMENT", category: "NON-TRANSPORT" },
  { name: "EXCAVATOR (NT)", category: "NON-TRANSPORT" },
  { name: "CRANE MOUNTED VEHICLE", category: "NON-TRANSPORT" },
  { name: "FORK LIFT", category: "NON-TRANSPORT" },
  { name: "VEHICLE FITTED WITH GENERATOR", category: "NON-TRANSPORT" },
  { name: "TREE TRIMMING VEHICLE", category: "NON-TRANSPORT" },
  { name: "CONSTRUCTION EQUIPMENT VEHICLE", category: "NON-TRANSPORT" },
  { name: "RECOVERY VEHICLE", category: "NON-TRANSPORT" },
  { name: "ROAD ROLLER", category: "NON-TRANSPORT" },
  { name: "TOWER WAGON", category: "NON-TRANSPORT" },
  { name: "BREAKDOWN VAN", category: "NON-TRANSPORT" },
  { name: "TOW TRUCK", category: "NON-TRANSPORT" },
  { name: "CAMPER VAN / TRAILER (PRIVATE USE)", category: "NON-TRANSPORT" },
  { name: "VEHICLE FITTED WITH COMPRESSOR", category: "NON-TRANSPORT" },
  { name: "ARMOURED / SPECIALISED VEHICLE", category: "NON-TRANSPORT" },
  { name: "QUADRICYCLE (PRIVATE)", category: "NON-TRANSPORT" },
  { name: "HARVESTER", category: "NON-TRANSPORT" },
  { name: "THREE WHEELER (PERSONAL)", category: "NON-TRANSPORT" },
  { name: "POWER TILLER", category: "NON-TRANSPORT" },
  { name: "TRAILER FOR PERSONAL USE", category: "NON-TRANSPORT" },
];
const tamilNaduVehicleCategories = {
  PASSENGER: ["LIGHT PASSENGER VEHICLE", "MEDIUM PASSENGER VEHICLE", "HEAVY PASSENGER VEHICLE"],
  GOODS: ["LIGHT GOODS VEHICLE", "MEDIUM GOODS VEHICLE", "HEAVY GOODS VEHICLE"],
  "NON-TRANSPORT": ["LIGHT MOTOR VEHICLE", "MEDIUM MOTOR VEHICLE", "HEAVY MOTOR VEHICLE"],
};

const Tamilnadu = () => {
  const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "null");

  const state = "tamilnadu";
  const history = useHistory();

  // all input fields
  const [payLoad, setPayLoad] = useState({
    vehicleNo: "",
    chassisNo: "",
    mobileNo: "",
    ownerName: "",
    fromState: "",

    vehiclePermitType: "",
    vehicleClass: "",
    vehicleCategory: "",
    permitType: "",
    issuingAuthority: "",

    grossVehicleWeight: "",
    unladenWeight: "",
    seatingCapacityExcludingDriver: "",
    sleeperCapacityExcludingDriver: "",

    additionalSeatingCapacity: "",
    additionalSleeperCapacity: "",

    insuranceValidity: "",
    fitnessValidity: "",

    puccValidity: "",
    taxMode: "",

    permitAuthorizationNo: "",
    permitAuthorizationValidity: "",

    greenTaxValidity: "",
    regnDate: "",

    rtoName: "",
    permitValidity: "",

    borderBarrier: "",
    permitNo: "",

    taxFromDate: "",
    taxUptoDate: "",

    totalAmount: "",
    infraCess: "",
    mvTax: "",
    permitFee: "",
    userCharge: "",
    welfareTax: "",
    permitEndoresment: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const form = useRef(null);

  const getDetailsHandler = async () => {
    if (!payLoad.vehicleNo) {
      alert("Please enter vehicle no.");
      return;
    }
    setIsLoading(true);
    const { data } = await getDetailsApi({
      vehicleNo: payLoad.vehicleNo,
    });
    setIsLoading(false);
    if (data && data.success) {
setPayLoad((e) => ({
        ...e,
        ...mergeLookupDetails(e, data.detail),
      }));
    }
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!payLoad.unladenWeight) {
      payLoad.unladenWeight = 0;
    }

    payLoad.totalAmount =
      +payLoad.permitFee + +payLoad.mvTax + +payLoad.userCharge + +payLoad.welfareTax;

    history.push("/select-payment", {
      formData: {
        ...payLoad,
        state,
      },
    });
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setPayLoad((old) => {
      const updatedData = { ...old, [name]: value };
      if (name === "vehiclePermitType") {
        updatedData.vehicleClass = "";
        updatedData.vehicleCategory = "";
      }
      if (name === "vehicleClass") updatedData.vehicleCategory = "";
      return updatedData;
    });
  };

  const onResetHandler = () => {
    let x = { ...payLoad };
    let p = {};
    Object.keys(x).forEach((e) => {
      p[e] = "";
    });
    setPayLoad({ ...p });
  };

  if (!isLoggedIn || !isLoggedIn.accessState || !isLoggedIn.accessState.includes(fields.stateName.tamilNadu)) {
    return (
      <>
        <Header />
        <div className="container text-center mt-4 ">
          <h3>No Access of this state</h3>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="text-center">
        <p className="login-heading mt-4">
          <b>BORDER TAX PAYMENT FOR ENTRY INTO</b> <span>TAMIL NADU</span>
        </p>
      </div>
      <div className="box box--main">
        <div className="box__heading--blue">Tax Payment Details</div>
        <form
          ref={form}
          onSubmit={onSubmitHandler}
          className="service-type tax-details mt-4"
        >
          <div className="row">
            <div className="col-6">
              {/* left column (kept as provided) */}
              {/* vehicle number */}
              <div className="form__control">
                <label className="form__label d-block w-100 text-left" htmlFor="vehicleNo">
                  Vehicle No.<sup>*</sup>
                </label>
                <input
                  tabIndex="1"
                  required
                  maxLength="10"
                  autoFocus
                  inputMode="text"
                  disabled={isLoading}
                  value={payLoad.vehicleNo}
                  onChange={onChangeHandler}
                  className="form__input w-100"
                  type="text"
                  id="vehicleNo"
                  name="vehicleNo"
                />
              </div>

              {/* chassis */}
              <div className="form__control">
                <label className="form__label d-block w-100 text-left" htmlFor="chassisNo">
                  Chassis No.<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="2"
                  maxLength="19"
                  inputMode="text"
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.chassisNo}
                  className="form__input w-100"
                  type="text"
                  id="chassisNo"
                  name="chassisNo"
                />
              </div>

              {/* mobile */}
              <div className="form__control">
                <label className="form__label d-block w-100 text-left" htmlFor="mobileNo">
                  Mobile No.<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="3"
                  disabled={isLoading}
                  value={payLoad.mobileNo}
                  onChange={onChangeHandler}
                  placeholder="SMS about payment will be sent to this number "
                  className="form__input w-100"
                  type="text"
                  id="mobileNo"
                  inputMode="tel"
                  maxLength="10"
                  minLength="10"
                  name="mobileNo"
                />
              </div>

              {/* vehicle type & class */}
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="vehiclePermitType">
                      Vehicle Type<sup>*</sup>
                    </label>
                    <select
                      tabIndex="4"
                      value={payLoad.vehiclePermitType}
                      onChange={onChangeHandler}
                      required
                      name="vehiclePermitType"
                      id="vehiclePermitType"
                    >
                      <option value="">--Select Vehicle Type--</option>
                      {tamilNaduVehicleTypes.map((type) => {
                        return (
                          <option value={type} key={type}>
                            {type}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="vehicleClass">
                      Vehicle Class<sup>*</sup>
                    </label>
                    <select
                      tabIndex="11"
                      required
                      disabled={isLoading}
                      value={payLoad.vehicleClass}
                      onChange={onChangeHandler}
                      name="vehicleClass"
                      id="vehicleClass"
                    >
                      <option value="">--Select Vehicle Class--</option>
                      {tamilNaduVehicleClasses
                        .filter((vehicleClass) => vehicleClass.category === payLoad.vehiclePermitType)
                        .map((vehicleClass) => (
                          <option value={vehicleClass.name} key={vehicleClass.name}>
                            {vehicleClass.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form__control">
                <label className="form__label d-block w-100 text-left" htmlFor="vehicleCategory">
                  Vehicle Category<sup>*</sup>
                </label>
                <select
                  tabIndex="12"
                  required
                  disabled={isLoading}
                  value={payLoad.vehicleCategory}
                  onChange={onChangeHandler}
                  name="vehicleCategory"
                  id="vehicleCategory"
                >
                  <option value="">--Select Vehicle Category--</option>
                  {(payLoad.vehiclePermitType === "NON-TRANSPORT"
                    ? tamilNaduVehicleCategories["NON-TRANSPORT"]
                    : tamilNaduVehicleCategories[
                        tamilNaduVehicleClasses.find((vehicleClass) => vehicleClass.name === payLoad.vehicleClass)?.type
                      ] || []
                  ).map((vehicleCategory) => (
                    <option value={vehicleCategory} key={vehicleCategory}>
                      {vehicleCategory}
                    </option>
                  ))}
                </select>
              </div>

              {/* conditional forms: seating/gross/unladen */}
              {tamilNaduVehicleClasses.find((vehicleClass) => vehicleClass.name === payLoad.vehicleClass)?.type === "PASSENGER" ? (
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label className="form__label d-block w-100 text-left" htmlFor="seatingCapacityExcludingDriver">
                        Seating Capacity(Ex. Driver)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.seatingCapacityExcludingDriver}
                        id="seatingCapacityExcludingDriver"
                        name="seatingCapacityExcludingDriver"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form__control">
                      <label className="form__label d-block w-100 text-left" htmlFor="sleeperCapacityExcludingDriver">
                        Sleeper Capacity <sup>*</sup>
                      </label>
                      <input
                        tabIndex="6"
                        required
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        value={payLoad.sleeperCapacityExcludingDriver}
                        className="form__input w-100"
                        type="number"
                        id="sleeperCapacityExcludingDriver"
                        name="sleeperCapacityExcludingDriver"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label className="form__label d-block w-100 text-left" htmlFor="grossVehicleWeight">
                        Gross Vehicle Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.grossVehicleWeight}
                        id="grossVehicleWeight"
                        name="grossVehicleWeight"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form__control">
                      <label className="form__label d-block w-100 text-left" htmlFor="unladenWeight">
                        Unladen Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex="5"
                        min="0"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        value={payLoad.unladenWeight}
                        id="unladenWeight"
                        name="unladenWeight"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* left-column additional inputs (insurance, fitness, etc.) */}
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="insuranceValidity">
                      Insurance Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="insuranceValidity"
                      name="insuranceValidity"
                      onChange={onChangeHandler}
                      value={payLoad.insuranceValidity}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="fitnessValidity">
                      Fitness Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="roadTaxValidity"
                      name="fitnessValidity"
                      type="datetime-local"
                      value={payLoad.fitnessValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="permitAuthorizationNo">
                      Permit Authorization No.<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="permitAuthorizationNo"
                      name="permitAuthorizationNo"
                      type="number"
                      value={payLoad.permitAuthorizationNo}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="permitAuthorizationValidity">
                      Permit Authorization Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="permitAuthorizationValidity"
                      name="permitAuthorizationValidity"
                      type="datetime-local"
                      value={payLoad.permitAuthorizationValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                {/* RTO / permit validity */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="rtoName">
                      District / RTO Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex="12"
                      disabled={isLoading}
                      required
                      onChange={onChangeHandler}
                      value={payLoad.rtoName}
                      name="rtoName"
                      id="rtoName"
                    >
                      <option value="">--Select District Name--</option>
                      {fields?.taminadu?.rtoName.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="permitValidity">
                      Permit Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="permitValidity"
                      name="permitValidity"
                      type="datetime-local"
                      value={payLoad.permitValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                {/* Checkpost select depends on rtoName (kept inline as in user's code) */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="borderBarrier">
                      Checkpost Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex="12"
                      disabled={isLoading}
                      required
                      onChange={onChangeHandler}
                      value={payLoad.borderBarrier}
                      name="borderBarrier"
                      id="borderBarrier"
                    >
                      <option value="">--Select Checkpost Name--</option>
                      {/* list is driven by rtoName — keep the same logic as your provided file */}
                      {payLoad.rtoName === "COIMBATORE WEST" &&
                        ["K.G. CHAVADI (IC)", "K.G. CHAVADI (OG)"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "GOBICHETTIPALAYAM" &&
                        ["BANNARI"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "HOSUR" &&
                        ["BAGALUR", "HOSUR (I/C)", "HOSUR (O/G)"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "KRISHNAGIRI" &&
                        ["KALIKOVIL"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "MARTHANDHAM" &&
                        ["KALIYAKAVILAI"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "OOTY" &&
                        ["GUDALUR", "NADUKANI"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "PETHIKUPPAM" &&
                        ["PETHIKUPPAM"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "POLLACHI" &&
                        ["GOPALAPURAM", "VALANTHAYAMARAM"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "POONAMALLEE" &&
                        ["POONAMALLEE"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "TENKASI" &&
                        ["PULIYARAI"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "THENI" &&
                        ["P.C. PATTI"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "TINDIVANAM" &&
                        ["THIRUCHITRAMBALAM"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                      {payLoad.rtoName === "VELLORE" &&
                        ["KATPADI", "SERKADU"].map((name) => {
                          return (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="permitNo">
                      Permit No.<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="permitNo"
                      name="permitNo"
                      type="text"
                      value={payLoad.permitNo}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* right column */}
            <div className="col-6">
              <div className="form__control text-left">
                <label className="form__label d-block w-100 text-left">&nbsp;</label>
                {isLoading && <Loader className="loader__get-details" />}
                {!isLoading && (
                  <button
                    disabled={isLoading}
                    type="button"
                    onClick={getDetailsHandler}
                    className="box__button get-details"
                  >
                    <span className="glyphicon glyphicon-arrow-down mr-3"></span>
                    Get Details
                  </button>
                )}
              </div>

              {/* owner name */}
              <div className="form__control">
                <label className="form__label d-block w-100 text-left" htmlFor="ownerName">
                  Owner Name<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="9"
                  disabled={isLoading}
                  className="form__input w-100"
                  type="text"
                  id="ownerName"
                  inputMode="text"
                  name="ownerName"
                  onChange={onChangeHandler}
                  value={payLoad.ownerName}
                />
              </div>

              {/* from state */}
              <div className="form__control">
                <label className="form__label d-block w-100 text-left" htmlFor="fromState">
                  From State<sup>*</sup>
                </label>
<select
                  tabIndex="10"
                  disabled={isLoading}
                  required
                  value={payLoad.fromState}
                  onChange={onChangeHandler}
                  name="fromState"
                  id="fromState"
                >
                  <option value="">--Select State--</option>
                  {fields.fromState.map((type) => {
                    return (
                      <option key={type.name} value={String(type.name).toUpperCase()}>
                        {type.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* permit type / issuing authority */}
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="permitType">
                      Permit Type<sup>*</sup>
                    </label>
                    <select
                      required
                      tabIndex="12"
                      disabled={isLoading}
                      value={payLoad.permitType}
                      onChange={onChangeHandler}
                      name="permitType"
                      id="permitType"
                    >
                      <option value="">--Select Permit Type--</option>
                      {fields.taminadu.permitType.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="issuingAuthority">
                      Issuing Authority
                    </label>
                    <input
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="text"
                      id="issuingAuthority"
                      name="issuingAuthority"
                      onChange={onChangeHandler}
                      value={payLoad.issuingAuthority}
                    />
                  </div>
                </div>
              </div>

              {/* additional capacities */}
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="additionalSeatingCapacity">
                      Additional Seating Capacity.<sup>*</sup>
                    </label>
                    <input
                      className="form__input w-100"
                      type="text"
                      required
                      tabIndex="12"
                      disabled={isLoading}
                      value={payLoad.additionalSeatingCapacity}
                      onChange={onChangeHandler}
                      name="additionalSeatingCapacity"
                      id="additionalSeatingCapacity"
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="additionalSleeperCapacity">
                      Additional Sleeper Capacity.<sup>*</sup>
                    </label>
                    <input
                      className="form__input w-100"
                      type="text"
                      required
                      tabIndex="12"
                      disabled={isLoading}
                      value={payLoad.additionalSleeperCapacity}
                      onChange={onChangeHandler}
                      name="additionalSleeperCapacity"
                      id="additionalSleeperCapacity"
                    />
                  </div>
                </div>
              </div>

              {/* PUCC & tax mode */}
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="puccValidity">
                      PUCC Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="puccValidity"
                      name="puccValidity"
                      type="datetime-local"
                      value={payLoad.puccValidity}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="taxMode">
                      Tax Mode<sup>*</sup>
                    </label>
                    <select
                      tabIndex="12"
                      disabled={isLoading}
                      required
                      onChange={onChangeHandler}
                      value={payLoad.taxMode}
                      name="taxMode"
                      id="taxMode"
                    >
                      <option value="">--Select Tax Mode--</option>
                      {fields?.taminadu?.taxMode.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>

              {/* green/regn/tax dates */}
              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="greenTaxValidity">
                      Green Tax Validity<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="greenTaxValidity"
                      name="greenTaxValidity"
                      onChange={onChangeHandler}
                      value={payLoad.greenTaxValidity}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="regnDate">
                      Regn Date<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="roadTaxValidity"
                      name="regnDate"
                      type="datetime-local"
                      value={payLoad.regnDate}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="taxFromDate">
                      Tax From Date<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="15"
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="taxFromDate"
                      name="taxFromDate"
                      onChange={onChangeHandler}
                      value={payLoad.taxFromDate}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left" htmlFor="taxUptoDate">
                      Tax Upto Date<sup>*</sup>
                    </label>
                    <input
                      required
                      tabIndex="16"
                      disabled={isLoading}
                      className="form__input w-100"
                      id="taxUptoDate"
                      name="taxUptoDate"
                      type="datetime-local"
                      value={payLoad.taxUptoDate}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* tax table */}
          <div className="row mt-3">
            <div className="col-12">
              <table className="hr-table">
                <thead>
                  <tr>
                    <th className="hr-table-1">SI. No.</th>
                    <th className="hr-table-2">Particulars</th>
                    <th>Tax From</th>
                    <th>Tax Upto</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="">1</td>
                    <td className="pb-table-text">Permit Fee</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          required
                          disabled={isLoading}
                          value={payLoad.permitFee}
                          onChange={onChangeHandler}
                          name="permitFee"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td className="">2</td>
                    <td className="pb-table-text">MV Tax</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          required
                          disabled={isLoading}
                          value={payLoad.mvTax}
                          onChange={onChangeHandler}
                          name="mvTax"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>

                  <tr>
                    <td className="">3</td>
                    <td className="pb-table-text">Service/User Charge</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          required
                          disabled={isLoading}
                          value={payLoad.userCharge}
                          onChange={onChangeHandler}
                          name="userCharge"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>

                  <tr>
                    <td className="">4</td>
                    <td className="pb-table-text">Welfare Tax</td>
                    <td className=""></td>
                    <td className=""></td>
                    <td className="input-box">
                      <center>
                        <input
                          tabIndex="17"
                          required
                          disabled={isLoading}
                          value={payLoad.welfareTax}
                          onChange={onChangeHandler}
                          name="welfareTax"
                          type="number"
                          min="0"
                          inputMode="numeric"
                        />
                      </center>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <br />
          <div className="row">
            <div className="col-sm-6">
              <div className="form__control">
                <label className="form__label d-block w-100 text-left" htmlFor="totalAmount">
                  Total amount<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="18"
                  disabled
                  min="0"
                  value={+payLoad.permitFee + +payLoad.mvTax + +payLoad.userCharge + +payLoad.welfareTax}
                  className="form__input w-100"
                  type="number"
                  id="totalAmount"
                  name="totalAmount"
                />
              </div>
            </div>

            <div className="col-sm-6">
              <label className="form__label d-block w-100 text-left">&nbsp;</label>
              <ActionButtons tabIndex="19" isDisabled={isLoading} onReset={onResetHandler} />
            </div>
          </div>
        </form>
        <br />
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default Tamilnadu;
